import script from "./ShellGame.vue?vue&type=script&setup=true&lang=js"
export * from "./ShellGame.vue?vue&type=script&setup=true&lang=js"

import "./ShellGame.vue?vue&type=style&index=0&id=c26502a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c26502a4"]])

export default __exports__